import React from "react";
import { useAppSelector, useAppDispatch } from "../../../../../redux/store";
import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
// import TeamCard from "../TeamCard.jsx";

import {
  Box,
  Tabs,
  Tab,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  List,
  ListItem,
  Checkbox,
} from "@mui/material";
import {
  Add as AddIcon,
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import {
  handleTeamChange,
  addTeamCategory,
  renameTeamCategory,
  deleteTeamCategory,
  selectTeamWithUserData,
  setMeetYourTeamHeader,
  setMeetYourTeamTextBox,
} from "../../../../../redux/slices/customersSlice";

const TeamTab = (/*{ label = "Select user", placeholder = "Search…" } /*/) => {
  const dispatch = useAppDispatch();
  const { users: usersArray } = useAppSelector((state) => state.users) as any;

  const { meetYourTeamHeader, meetYourTeamTextBox, changes } = useAppSelector(
    (state) => state.customers,
  ) as any;

  const [activeCategory, setActiveCategory] = React.useState(0);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogMode, setDialogMode] = React.useState("add"); // "add" or "rename"
  const [categoryName, setCategoryName] = React.useState("");
  const [editingCategory, setEditingCategory] = React.useState("");
  const [menuAnchor, setMenuAnchor] = React.useState<any>(null);
  const [selectedTabForMenu, setSelectedTabForMenu] = React.useState<any>(null);

  const teamData = useAppSelector(selectTeamWithUserData) as any;

  const categories = React.useMemo(() => {
    return Object.keys(teamData);
  }, [teamData]);

  const teamEligibleUsers = React.useMemo(() => {
    return usersArray.filter(
      (user: any) =>
        user.role === "admin" ||
        user.role === "super-admin" ||
        user.role === "employee",
    );
  }, [usersArray]);

  const allPositions = React.useMemo(
    () => Array.from(new Set(teamEligibleUsers.map((user: any) => user.position))),
    [teamEligibleUsers],
  );

  const positionOrderIndex = React.useMemo(() => {
    const map = new Map();
    allPositions.forEach((position, index) => map.set(position, index));
    return map;
  }, [allPositions]);

  const sortedUsers = React.useMemo(() => {
    return [...teamEligibleUsers].sort((userA, userB) => {
      const groupIndex =
        positionOrderIndex.get(userA?.position) -
        positionOrderIndex.get(userB?.position);
      if (groupIndex !== 0) return groupIndex;
      return userA.fullName?.localeCompare(userB?.fullName);
    });
  }, [usersArray, positionOrderIndex]);

  // const filterUsers = (userArray, state) => {
  //   const searchQuery = (state?.inputValue || "").toLowerCase();
  //   if (!searchQuery) return userArray;

  //   return userArray.filter((user) =>
  //     [user?.fullName, user?.position, user?.email,]
  //       .filter(Boolean)
  //       .some((field) => field.toLowerCase().includes(searchQuery))
  //   );
  // };

  const currentCategory = categories[activeCategory];
  const selectedUsers = teamData[currentCategory] || [];

  const handleUsersChange = (_: any, newSelectedUsers: any) => {
    const updatedTeam = {
      ...teamData,
      [currentCategory]: newSelectedUsers,
    };
    dispatch(handleTeamChange(updatedTeam));
  };

  // Dialog handlers
  const handleAddCategory = () => {
    setDialogMode("add");
    setCategoryName("");
    setDialogOpen(true);
  };

  const handleRenameCategory = (categoryName: any) => {
    setDialogMode("rename");
    setCategoryName(categoryName);
    setEditingCategory(categoryName);
    setDialogOpen(true);
    setMenuAnchor(null);
  };

  const handleDeleteCategory = (categoryName: any) => {
    dispatch(deleteTeamCategory({ categoryName }));
    if (categories[activeCategory] === categoryName) {
      setActiveCategory(0);
    } else if (
      activeCategory > 0 &&
      categories.indexOf(categoryName) < activeCategory
    ) {
      setActiveCategory(activeCategory - 1);
    }
    setMenuAnchor(null);
  };

  const handleDialogSave = () => {
    if (!categoryName.trim()) return;

    if (dialogMode === "add") {
      dispatch(addTeamCategory({ categoryName: categoryName.trim() }));
      setActiveCategory(categories.length);
    } else if (dialogMode === "rename") {
      dispatch(
        renameTeamCategory({
          oldName: editingCategory,
          newName: categoryName.trim(),
        }),
      );
    }

    setDialogOpen(false);
    setCategoryName("");
    setEditingCategory("");
  };

  const handleDialogCancel = () => {
    setDialogOpen(false);
    setCategoryName("");
    setEditingCategory("");
  };

  const handleMenuOpen = (event: any, categoryName: any) => {
    event.stopPropagation();
    setMenuAnchor(event.currentTarget);
    setSelectedTabForMenu(categoryName);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedTabForMenu(null);
  };

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Text Field  block*/}
        <Box sx={{ width: "100%", mb: 2 }}>
          <TextField
            fullWidth
            label="Team Section Title"
            value={
              changes?.meetYourTeamHeader === undefined
                ? meetYourTeamHeader || ""
                : changes?.meetYourTeamHeader
            }
            onChange={(e) => dispatch(setMeetYourTeamHeader(e.target.value))}
            sx={{ pb: 2 }}
          />

          <TextField
            fullWidth
            label="Team Section Description"
            multiline
            value={
              changes?.meetYourTeamTextBox === undefined
                ? meetYourTeamTextBox || ""
                : changes?.meetYourTeamTextBox
            }
            onChange={(e) => dispatch(setMeetYourTeamTextBox(e.target.value))}
            sx={{ mb: 1 }}
          />
        </Box>
        {/* Tabs & Autocomplete */}
        <Box
          sx={{
            display: "flex",
            width: "100%",
          }}
        >
          <Box sx={{ borderRight: 1, borderColor: "divider", minWidth: 200 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
              }}
            >
              <Box
                component="h6"
                sx={{ m: 0, fontSize: "0.875rem", fontWeight: 600 }}
              >
                Team Categories
              </Box>
              <IconButton
                size="small"
                onClick={handleAddCategory}
                title="Add Category"
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>

            <Tabs
              orientation="vertical"
              value={activeCategory}
              onChange={(_: any, newValue) => setActiveCategory(newValue)}
              sx={{ mt: 1 }}
            >
              {categories.map((category, index) => (
                <Tab
                  key={category}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{category}</span>
                      <Box
                        component="span"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMenuOpen(e, category);
                        }}
                        sx={{
                          ml: 1,
                          p: 0.5,
                          borderRadius: 0,
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "action.hover",
                          },
                        }}
                      >
                        <MoreVertIcon fontSize="small" />
                      </Box>
                    </Box>
                  }
                  value={index}
                  sx={{
                    alignItems: "flex-start",
                    "& .MuiTab-wrapper": {
                      width: "100%",
                      alignItems: "flex-start",
                    },
                  }}
                />
              ))}
            </Tabs>
          </Box>
          <Box sx={{ width: "100%", pl: 2, pr: 2 }}>
            {/* Single master list of all users */}
            <List>
              {sortedUsers.map((user) => {
                const isSelected = selectedUsers.some((u: any) => u.id === user.id);

                return (
                  <ListItem
                    key={user.id}
                    sx={{
                      borderBottom: "1px solid #eee",
                      py: 1,
                      display: "flex",
                      alignItems: "center",
                    }}
                    secondaryAction={
                      <Checkbox
                        edge="end"
                        checked={isSelected}
                        onChange={() => {
                          const updated = isSelected
                            ? selectedUsers.filter((u: any) => u.id !== user.id)
                            : [...selectedUsers, user];

                          handleUsersChange(null, updated);
                        }}
                      />
                    }
                  >
                    <Avatar
                      src={user.photo}
                      alt={user.fullName}
                      sx={{ width: 40, height: 40, mr: 2 }}
                    >
                      {user.fullName?.[0]}
                    </Avatar>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <strong>{user.fullName}</strong>
                        <Chip
                          label={user.role}
                          size="small"
                          sx={{ fontSize: "0.7rem", height: 20 }}
                        />
                      </Box>
                      <span style={{ fontSize: "0.85rem", color: "#777" }}>
                        {user.position}
                      </span>
                    </Box>
                  </ListItem>
                );
              })}
            </List>
          </Box>
          {/* ==== */}
          {/* <Box sx={{ flexGrow: 1, pl: 2, pr: 2 }}>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={sortedUsers}
              groupBy={(user) => user.position}
              getOptionLabel={(user) => user.fullName}
              isOptionEqualToValue={(user, selectedUser) =>
                user.id === selectedUser.id
              }
              filterOptions={filterUsers}
              value={selectedUsers}
              onChange={handleUsersChange}
              renderGroup={(params) => (
                <li key={params.key}>
                  <GroupHeader>{params.group}</GroupHeader>
                  <GroupItems>{params.children}</GroupItems>
                </li>
              )}
              renderOption={(props, user) => (
                <li {...props} key={user.id}>
                  <Avatar sx={{ mr: 1 }} src={user.photo} alt={user.fullName}>
                    {user?.fullName?.[0]}
                  </Avatar>
                  {user?.fullName}
                </li>
              )}
              renderTags={(selectedUsers, getTagProps) =>
                selectedUsers.map((user, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={user.id}
                    label={user.fullName}
                    avatar={
                      <Avatar src={user.photo} alt={user.fullName}>
                        {user.fullName?.[0]}
                      </Avatar>
                    }
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  placeholder={placeholder}
                />
              )}
              sx={{ minWidth: "57vh", mb: 4 }}
            />

            <Grid container>
              {selectedUsers.map((user, i) => (
                <Grid size={{ xs: 12, md: 12 }} key={i}>
                  <TeamCard user={user} />
                </Grid>
              ))}
            </Grid>
          </Box> */}
        </Box>
        {/* === */}
      </Box>

      {/* Context Menu */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={() => handleRenameCategory(selectedTabForMenu)}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Rename</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => handleDeleteCategory(selectedTabForMenu)}
          disabled={categories.length <= 1}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
      {/* Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={handleDialogCancel}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Category" : "Rename Category"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Category Name"
            fullWidth
            variant="outlined"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleDialogSave();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogCancel}>Cancel</Button>
          <Button
            onClick={handleDialogSave}
            variant="contained"
            disabled={!categoryName.trim()}
          >
            {dialogMode === "add" ? "Add" : "Rename"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TeamTab;
